import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { StyledButton, toasty } from '../../../../common/forms/FormElements';

export const PhoneNumber = ({ phoneNumber }) => {
    if (!phoneNumber) {
        return null;
    }

    return (
        <StyledButton
            color="warning"
            outlined
            onClick={(e) => {
                e.stopPropagation();
                navigator.clipboard.writeText(phoneNumber)
                    .then(() => toasty.success(`Copied ${phoneNumber} to clipboard`))
                    .catch(() => toasty.error('Failed to copy phone number'));
            }}
        >
            <FontAwesomeIcon
                icon={faPhone}
                className="mr-1"
            />
            {phoneNumber}
        </StyledButton>
    );
};